module.exports = __webpack_public_path__ + "img/top_safe02.4b24c869.png";